import { z } from 'zod';
import { zSet, zSetMetric, zExerciseMetric } from '../core';
export const SchemeLibraryModule = 'SchemeLibrary';
const module = z.literal(SchemeLibraryModule);
const zSchemeSet = zSet.merge(z.object({
    id: z.uuid(),
    cycleIndex: z.number().int().nonnegative(),
    sessionIndex: z.number().int().nonnegative(),
    metrics: z.array(zSetMetric.omit({ dataSource: true }).merge(z.object({ id: z.uuid() }))),
}));
const zSchemeMetric = zExerciseMetric.merge(z.object({ id: z.uuid() }));
export const BaseSchemeSchema = z.object({
    id: z.uuid(),
    name: z.string(),
    trainingTypeId: z.uuid(),
    focuses: z.array(z.object({
        id: z.uuid(),
        focusId: z.uuid(),
        sortOrder: z.number(),
    })),
    metrics: z.array(zSchemeMetric),
    sets: z.array(zSchemeSet),
});
export const CreateScheme = z.object({
    module,
    type: z.literal('CreateScheme'),
    input: BaseSchemeSchema,
});
export const EditScheme = z.object({
    module,
    type: z.literal('EditScheme'),
    input: BaseSchemeSchema,
});
const zSchemeFormWorkoutSet = z.object({
    id: z.uuid(),
    metrics: z.array(zSetMetric.omit({ dataSource: true }).merge(z.object({ id: z.uuid() }))),
});
const zSchemeFormWorkout = z.object({
    sets: z.array(zSchemeFormWorkoutSet),
});
export const SchemeFormSchema = BaseSchemeSchema.omit({
    id: true,
    sets: true,
    focuses: true,
}).merge(z.object({
    workouts: z.array(zSchemeFormWorkout),
    focusIds: z.array(z.string()),
}));
export const SearchSchemes = z.object({
    module,
    type: z.literal('SearchSchemes'),
    input: z.object({
        searchTerm: z.string().optional(),
        limit: z.number().int().nonnegative().optional(),
        focusIds: z.array(z.string()).optional(),
    }),
});
//# sourceMappingURL=commands.js.map